export default __webpack_public_path__ + "img/business-intelligence.a2a00c.svg";